import { isApiMenuSource } from "@/config/menuSource";
// Combo / bundle data model. Components reference product ids; the combo is
// added to the cart as a single line at a fixed price (shows savings vs. sum).
const img = (u) => `${u}?w=900&q=80`;

const mockCombos = [
  {
    id: "combo_burger_menu",
    name: { tr: "Burger Menü", en: "Burger Combo", de: "Burger-Menü", ar: "وجبة برجر", ru: "Бургер-меню", fr: "Menu Burger" },
    description: {
      tr: "Fudi Signature Burger + Elma Dilim Patates + İçecek",
      en: "Fudi Signature Burger + Potato Wedges + Drink",
      de: "Fudi Signature Burger + Kartoffelecken + Getränk",
      ar: "برجر فودي + بطاطس + مشروب",
      ru: "Бургер Fudi + картофель + напиток",
      fr: "Burger Fudi + potatoes + boisson",
    },
    image: img("https://images.unsplash.com/photo-1610440042657-612c34d95e9f"),
    price: 365, // fixed combo price
    componentIds: ["p_fudi_burger", "p_fries", "p_latte"],
    popular: true,
    available: true,
  },
  {
    id: "combo_pizza_duo",
    name: { tr: "Pizza İkili", en: "Pizza Duo", de: "Pizza Duo", ar: "بيتزا ثنائية", ru: "Пицца дуэт", fr: "Duo Pizza" },
    description: {
      tr: "Margherita + Pepperoni + 2 İçecek",
      en: "Margherita + Pepperoni + 2 Drinks",
      de: "Margherita + Pepperoni + 2 Getränke",
      ar: "مارغريتا + بيبروني + مشروبان",
      ru: "Маргарита + пепперони + 2 напитка",
      fr: "Margherita + Pepperoni + 2 boissons",
    },
    image: img("https://images.unsplash.com/photo-1579751626657-72bc17010498"),
    price: 540,
    componentIds: ["p_margherita", "p_pepperoni", "p_limonata", "p_ayran"],
    popular: false,
    available: true,
  },
];

// Demo combos only in "mock" mode; the guest menu API has no combos yet.
export const combos = isApiMenuSource() ? [] : [...mockCombos];

export function getComboById(id) {
  return combos.find((c) => c.id === id) || null;
}
